//トップページ　キービジュアルスライダー
export function idxFunc() {
  let indexTop = $("#indexTop").length;
  let resizecheck = $('#responsibleCheck').width();

  if(indexTop){
    let resizecheck = $('#responsibleCheck').width();
    let resizecheck2 = 0;
    
    $(window).on('load resize', function () {
      resizecheck = $('#responsibleCheck').width();
    });
    
    //FVアニメーション
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

    wait(0)
    .then(() =>{
      $("#indexTop").addClass('isShow');
      return wait(50)
    })
    .then(() =>{
      $(".mainviewImgAnime").addClass('isShow');
      return wait(800)
    })
    .then(() => {
      $('.mainviewTxtAnime').addClass('isShow');
      return wait(400)
    })

    function indexCommonAnimeFunc() {
      $('.commonTwoColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTxtBox').hasClass('isShow')) {
                $(this).find('.commonAnimeTxtBox').addClass('isShow');
              }
              return wait(400)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
      
      $('.commonTwoColumn02').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
      
      $('.commonFourColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox01').hasClass('isShow')) {
              $(this).find('.imgBox01').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(700)
          })
          .then(() => {
            if (!$(this).find('.imgBox02').hasClass('isShow')) {
              $(this).find('.imgBox02').addClass('isShow');
            }
            return wait(300)
          })
          .then(() => {
            if (!$(this).find('.imgBox03').hasClass('isShow')) {
              $(this).find('.imgBox03').addClass('isShow');
            }
            return wait(700)
          })
        }
      });

      $('.services').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(1000)
          })
          .then(() => {
              if (!$(this).find('.commonAnimeTit').hasClass('isShow')) {
                $(this).find('.commonAnimeTit').addClass('isShow');
                $(this).find('.commonAnimeTxt').addClass('isShow');
                $(this).find('.moreBtn').addClass('isShow');
              }
              return wait(100)
          })
          .then(() => {
            
            return wait(700)
          })
        }
      });

    }indexCommonAnimeFunc();

    $(window).on('load scroll', function () {
      indexCommonAnimeFunc();
    });
  }
}